module.exports = __webpack_public_path__ + "static/media/wallet-connect-wait.679416d6.svg";